import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("vsb_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Global 401 → drop token + bounce to landing. Guards the JWT rotation window
// (tokens signed with a rotated JWT_SECRET are silently invalidated).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!["/", "/vendors"].includes(path)) {
        localStorage.removeItem("vsb_token");
        localStorage.removeItem("vsb_user");
        window.location.assign("/");
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const fileUrl = (fileId) => fileId ? `${API}/files/${fileId}` : null;

export const authStore = {
  save(token, user) {
    localStorage.setItem("vsb_token", token);
    if (user) localStorage.setItem("vsb_user", JSON.stringify(user));
  },
  token() { return localStorage.getItem("vsb_token"); },
  user() {
    try { return JSON.parse(localStorage.getItem("vsb_user") || "null"); }
    catch { return null; }
  },
  clear() {
    localStorage.removeItem("vsb_token");
    localStorage.removeItem("vsb_user");
  },
};
